<template>
<!--Its an dialog window that opens when page are loading. giving an server message-->
  <v-app>
    <v-content class="pa-0">
      <v-dialog v-model="waitForServerResponse" fullscreen>
        <v-container fluid fill-height style="background-color: rgba(0,0,0,0.5)">
          <v-row align-center justify-center>
            <v-col xs12 sm8 md4>
              <v-card class="elevation-12">
                <v-toolbar center dark color="primary">
                  <v-spacer />
                  <v-toolbar-title v-text="waitForServerResponseMsg">
                    <v-progress-circular indeterminate class="ml-2" />
                  </v-toolbar-title>
                  <v-spacer />
                </v-toolbar>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-dialog>
      <router-view></router-view>
    </v-content>
  </v-app>
</template>


<script>
import headerDateLinksLeft from "./components/headerDateLinksLeft";
import headerModuleDivider from "./components/headermoduledivider";
import headerModuleUserNav from "./components/headermoduleusernav";
import { VueperSlides, VueperSlide } from "vueperslides";
import "vueperslides/dist/vueperslides.css";
import { mapGetters, mapActions } from "vuex";
import messages from "./modules/lang/main/export";

export default {
  i18n: { messages },
  components: {
    headerDateLinksLeft,
    headerModuleDivider,
    headerModuleUserNav,
    VueperSlides,
    VueperSlide
  },
  watch: {
    currentTag() {
      this.getArticles();
    },
    currentGeo() {
      this.getArticles();
    },
    TagProfiles() {
      this.updateTagList();
    },
    activeProfile(newVal) {
      localStorage.setItem("activeProfile", newVal);
      this.updateTagList();
    },
    "Geo.Search"(newVal) {
      // if (this.Geo.IsLoading) return;
      this.Geo.IsLoading = true;
      clearTimeout(this.Geo.SearchTimeout);
      this.Geo.SearchTimeout = setTimeout(() => {
        this.SEARCH_GEO_SUGGESTION(newVal)
          .then(resp => {
            this.Geo.SearchTags = resp.data.concat(this.newGeoTags);
          })
          .catch(ex => console.log(ex))
          .finally(() => {
            this.Geo.IsLoading = false;
          });
      }, 200);
    }
  },
  computed: {
    ...mapGetters([
      "isLoggedIn",
      "authStatus",
      "TagProfiles",
      "getTags",
      "userId"
    ]),
    firstTagProfile() {
      if (this.TagProfiles && this.TagProfiles.length > 0) {
        return this.TagProfiles[0];
      }
    },
    otherTagProfiles() {
      if (this.TagProfiles && this.TagProfiles.length > 1) {
        return this.TagProfiles.slice(1);
      }
    },
    TagsOrdered() {
      let _Tags = this.getTags;
      return _Tags.map(tag => {
        return {
          ...tag,
          Label: tag.TranslatedLabel ? tag.TranslatedLabel : tag.Label
        };
      });
    },
    LatestArticles() {
      return this.Articles.filter(res => res.ArticleType == "article");
    },
    Latest_nav_opprettelse_foretak() {
      return this.Articles.filter(
        res => res.ArticleType == "nav_opprettelse_foretak"
      );
    },
    Latest_nav_ledige_stillinger() {
      return this.Articles.filter(
        res => res.ArticleType == "nav_ledige_stillinger"
      );
    }
  },
  methods: {
    ...mapActions(["GET_FRONTPAGE", "SEARCH_GEO_SUGGESTION"]),
    getArticles() {
      if (this.Articles.length > 0) this.waitForServerResponse = true;
      this.waitForServerResponseMsg = "Sorting articles, please wait..";
      clearTimeout(this.articleTimeout);
      this.articleTimeout = setTimeout(() => {
        this.GET_FRONTPAGE({
          GeoTags: this.currentGeo,
          Tags: this.currentTag,
          Lang:
            localStorage.getItem("setlanguage") ||
            localStorage.getItem("detectedlanguage") ||
            "en",
          Search: this.activeProfile == "custom" ? this.SearchArticles : ""
        })
          .then(resp => {
            this.Articles = resp.data;
          })
          .catch(ex => {
            console.error(ex);
          })
          .finally(() => {
            this.waitForServerResponse = false;
          });
      }, 200);
    },
    updateTagList() {
      if (this.activeProfile == "custom") {
        console.log("custom profile");
        this.currentGeo = this.newGeoTags.map(res => res.id) || [];
        this.currentTag = this.newTags.map(res => res.id) || [];
      } else {
        if (this.TagProfiles && this.TagProfiles.length > 0) {
          let _index = 0;
          if (this.TagProfiles.hasOwnProperty(this.activeProfile)) {
            _index = this.activeProfile;
          } else {
            this.activeProfile = _index;
          }
          this.currentGeo =
            (
              this.TagProfiles[_index] && this.TagProfiles[_index]["GeoTags"]
            ).map(res => res.id) || [];
          this.currentTag =
            (this.TagProfiles[_index] && this.TagProfiles[_index]["Tags"]).map(
              res => res.id
            ) || [];
        } else {
          console.log("delaying updatetaglist");
          setTimeout(this.updateTagList, 200);
        }
      }
    },
    removeGeoTag(item) {
      this.newGeoTags = this.newGeoTags.filter(geo => geo.id != item.id);
    },
    removeTag(item) {
      this.newTags = this.newTags.filter(geo => geo.id != item.id);
    },
    selectedGeoEvent(evt) {
      this.Geo.Search = "";
    },
    selectedTagEvent(evt) {
      this.Tag.Search = "";
    },
    createTempProfile(evt) {
      localStorage.setItem("geotags", JSON.stringify(this.newGeoTags));
      localStorage.setItem(
        "geotags_searchitems",
        JSON.stringify(this.Geo.SearchTags)
      );
      localStorage.setItem("tags", JSON.stringify(this.newTags));
      // this.currentGeo = this.newGeoTags;
      // this.currentTag = this.newTags;
      this.activeProfile = "custom";
      localStorage.setItem("activeProfile", "custom");
      this.getArticles();
    }
  },
  data() {
    return {
      SERVERADRESS: process.env.VUE_APP_BASEAPI,
      waitForServerResponse: false,
      waitForServerResponseMsg: "Please wait...",
      activeProfile: localStorage.getItem("activeProfile") || 0,
      articleTimeout: null,
      currentGeo: [],
      currentTag: [],
      Articles: [],
      SearchArticles: "",
      newGeoTags: localStorage.getItem("geotags")
        ? JSON.parse(localStorage.getItem("geotags"))
        : [],
      Geo: {
        SearchTags: localStorage.getItem("geotags_searchitems")
          ? JSON.parse(localStorage.getItem("geotags_searchitems"))
          : [],
        SearchTimeout: null,
        IsLoading: false,
        Search: ""
      },
      newTags: localStorage.getItem("tags")
        ? JSON.parse(localStorage.getItem("tags"))
        : [],
      Tag: {
        SearchTags: [],
        SearchTimeout: null,
        IsLoading: false,
        Search: ""
      }
    };
  },

  mounted() {
    this.getArticles();
  }
};

function compareCreatedFunction(a, b) {
  let Property = "Created";
  if (a[Property] < b[Property]) return -1;
  if (a[Property] > b[Property]) return 1;
  return 0;
}
</script>

<style scoped>
.moduleheader {
  font-size: 2em;
  font-weight: 400;
  position: relative;
}
/* .moduleheader:after {
  content: "";
  position: absolute;
  left: 0;
  bottom: -24px;
  border-bottom: 2px solid #cc0000;
  width: 50px;
} */
.redborderbottom {
  border-bottom: 2px solid #cc0000 !important;
}
.topbar-container {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-content: stretch;
  align-items: flex-start;
}
.topbar-container > * {
  width: 100%;
  margin-bottom: 20px;
}

.topbar-container .left {
  order: 0;
  flex: 0 1 auto;
  align-self: auto;
  text-align: left;
}

.topbar-container .center {
  order: 0;
  flex: 0 2 auto;
  align-self: auto;
}
.topbar-container .center img {
  width: 150px;
}

.topbar-container .right {
  margin: 15px;
  order: 0;
  flex: 0 1 auto;
  align-self: auto;
  text-align: right;
}
.topbar-container .right a,
a.articlelinks {
  text-decoration: none;
  color: black;
}
.topbar-container .right a:hover,
a.articlelinks:hover {
  text-decoration: underline;
}
.topbar-menu-container {
  border-bottom: 4px solid black;
  padding-bottom: 20px;
}
.topbar-menu-container .flex {
  text-align: center;
  font-size: 1.2em;
}

.topbar-breakingnews {
  margin-top: 20px;
  border: 4px solid #000000;
  background-color: #000000;
}
.breakingnews.label {
  background-color: #000000;
  color: #ffffff;
  padding: 0 10px;
  position: relative;
}
.breakingnews.flashcolorred {
  animation: labelFlash linear 2s infinite;
}
@keyframes labelFlash {
  0% {
    color: #ffffff;
  }
  20% {
    color: #cc0000;
  }
  60% {
    color: #ffffff;
  }
  100% {
    color: #ffffff;
  }
}
/* .breakingnews.label:before {
  display: inline-block;
  font-style: normal;
  font-variant: normal;
  text-rendering: auto;
  -webkit-font-smoothing: antialiased;

  color: #cc0000;
  font-family: "Font Awesome 5 Free";
  font-weight: 900;
  content: "\f111";
  position: absolute;
  left: 4px;
  border-radius: 50%;
  border: 2px solid red;
  width: 23px;
} */

.breakingnews.redcircle {
  display: inline-block;
  background-color: #cc0000;
  border: 1px solid black;
  border-color: #000000;
  border-style: solid;

  box-shadow: 0 0 0 2px #dd0000;
  height: 10px;
  width: 10px;

  border-radius: 50%;
  -moz-border-radius: 50%;
  -webkit-border-radius: 50%;
  margin-right: 5px;
  position: relative;
  /* top:2px; */
  left: 5px;
  animation: circularshadowrotate linear 1s infinite;
}

@keyframes circularshadowrotate {
  0% {
    box-shadow: 0 0 0 2px #dd0000;
  }
  25% {
    box-shadow: 2px 0 0 2px #dd0000;
  }
  50% {
    box-shadow: 2px 2px 0 2px #dd0000;
  }
  75% {
    box-shadow: 0 2px 0 2px #dd0000;
  }
  100% {
    box-shadow: 0 0 0 2px #dd0000;
  }
}
.breakingnews.blackarrow {
  display: inline-block;
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 3.5px 0 3.5px 7px;
  border-color: transparent transparent transparent #000000;
}
.breakingnews.content {
  padding-left: 20px;
  width: 100%;
}
.breakingnews.whitearrow {
  display: inline-block;
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 3.5px 0 3.5px 7px;
  border-color: transparent transparent transparent #ffffff;
}
.breakingnews.readmore {
  background-color: #000000;
  color: #ffffff;
  padding: 1px 20px;
}

.greybottomborder {
  border-bottom: 2px solid #aeaeae !important;
}
</style>

<style>
.frontpageslideshow1 .vueperslides__bullets {
  left: auto;
  width: 30px;
  /* height: 50%; */
  bottom: 30px;
  right: 30px;
  flex-direction: column;
  justify-content: center;
  /* align-content: flex-end; */
  align-items: center;
  /* background-color: rgba(0,0,0,0.1); */
  z-index: 10;
}
.frontpageslideshow1 a {
  text-decoration: none;
  color: inherit;
}
.frontpageslideshow1 {
  color: white;
  text-shadow: -2px 0 black, 0 2px black, 2px 0 black, 0 -2px black;
}
.frontpageslideshow1 .vueperslides__bullet {
  background-color: rgba(0, 0, 0, 0);
  border: 1px solid rgba(255, 255, 255, 0.4);
  box-shadow: none;
  transition: 0.3s;
  width: 10px;
  height: 10px;
  margin: 4px 0;
}

.frontpageslideshow1 .vueperslides__bullet--active {
  background-color: #cc0000;
  border: 1px solid #cc0000;
}

.frontpageslideshow1 .vueperslides__bullet span {
  display: none;
}
</style>
